import React from "react";
 
class Support extends React.Component {
  render() {
    return (
      <div>
        <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css" />
        <h2>Questions?</h2>
        <br/>
        <p>The easiest thing to do is post on
        our slack channel <a href="https://ancestry.slack.com/messages/CCD077LDA/" target="_blank" rel="noopener noreferrer">here</a>.
        </p>
      </div>
    );
  }
}
 
export default Support;



// WEBPACK FOOTER //
// ./src/Support.js